module.exports = __webpack_public_path__ + "img/monitor_integrasi_api.60079129.svg";